import type { ChampionshipMatchStatus, ChampionshipStatus, ChampionshipTeam } from "@/types";

export const CHAMPIONSHIP_STATUS_LABEL: Record<ChampionshipStatus, string> = {
  BORRADOR: "Borrador",
  EN_CURSO: "En curso",
  FINALIZADO: "Finalizado",
  CANCELADO: "Cancelado",
};

export const MATCH_STATUS_LABEL: Record<ChampionshipMatchStatus, string> = {
  PROGRAMADO: "Programado",
  EN_JUEGO: "En juego",
  FINALIZADO: "Finalizado",
  CANCELADO: "Cancelado",
};

export function championshipTone(estado: ChampionshipStatus | ChampionshipMatchStatus): "green" | "red" | "slate" {
  if (estado === "EN_CURSO" || estado === "EN_JUEGO" || estado === "FINALIZADO") return "green";
  if (estado === "CANCELADO") return "red";
  return "slate";
}

export function personName(p: { nombre: string; apellidos: string | null }): string {
  return `${p.nombre}${p.apellidos ? ` ${p.apellidos}` : ""}`;
}

export function teamLabel(team: Pick<ChampionshipTeam, "nombre" | "jugador1" | "jugador2">): string {
  return team.nombre?.trim() || `${personName(team.jugador1)} / ${personName(team.jugador2)}`;
}

// <input type="datetime-local"> da "YYYY-MM-DDTHH:mm" SIN zona horaria, y el servidor lo
// interpretaría en SU zona (en producción puede no ser la de quien lo escribe). Convertirlo a ISO
// en el navegador fija el instante correcto.
export function localInputToIso(value: string): string | null {
  if (!value) return null;
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? null : d.toISOString();
}

export function isoToLocalInput(iso: string | null): string {
  if (!iso) return "";
  const d = new Date(iso);
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

export const dateTimeFormatter = new Intl.DateTimeFormat("es-ES", {
  weekday: "short",
  day: "2-digit",
  month: "short",
  hour: "2-digit",
  minute: "2-digit",
});

export function formatDateTime(iso: string | null): string {
  return iso ? dateTimeFormatter.format(new Date(iso)) : "Horario por definir";
}

export function matchLabel(m: { equipoA: ChampionshipTeam | null; equipoB: ChampionshipTeam | null }): { a: string; b: string } {
  return { a: m.equipoA ? teamLabel(m.equipoA) : "Por definir", b: m.equipoB ? teamLabel(m.equipoB) : "Por definir" };
}

export function apiError(error: unknown, fallback: string): string {
  return (error as { response?: { data?: { error?: string } } })?.response?.data?.error ?? fallback;
}
